
import { Emit, Component, Mixins, Ref, Prop, InjectReactive, Provide, ProvideReactive } from "vue-property-decorator";
import TablePagination from "@/mixins/tablePagination";
import Resize from "@/mixins/resize";

import ETable from "@/components/ETable.vue";

import { tongueSubSymptom, tongueSubSymptomList } from '@/api/tongue';

@Component({
    components: {
        ETable
    }
})
export default class TongueSubSymptomConfig extends Mixins(Resize, TablePagination) {
    @InjectReactive() subTabActiveName!: string;
    queryForm = {
        exSymptomName: "",
    }
    tableData: Array<any> = []
    columns = [
        { label: "ID", prop: "id", width: 80 },
        { label: "舌诊副症状", prop: "symptomName" },
        { label: "备注", prop: "remark" },
        { label: "操作人", prop: "modifiedBy" },
        { label: "最后操作时间", prop: "modifiedTime" },
        { label: "操作", prop: "action", width: 120 },
    ]

    dialogVisible = false
    dialogForm = {
        id: null,
        symptomName: "",
        remark: ""
    }
    dialogFormRules = {
        symptomName: [
            { required: true, message: "请输入舌诊副症状", trigger: "blur" },
            { max: 300, message: "最多300个字符", trigger: "blur" }
        ],
        remark: [
            { max: 200, message: "最多200个字符", trigger: "blur" }
        ]
    }
    searching = false
    saving = false

    mounted() {
        this.windowResize(310);
        this.getData();
    }

    async getData() {
        try {
            this.searching = true
            tongueSubSymptomList({
                ...this.queryForm, 
                pageNum: this.currentPage, 
                pageSize: this.pageSize
            }).then((res: any) => {
                this.tableData = res.data.list
                this.itemTotal = res.data.total
            })
        } catch (error) {
            console.error('获取数据失败', error)
            this.$message.error('获取数据失败')
        } finally {
            this.searching = false
        }
    }

    search() {
        this.resetCurrent()
        this.getData()
    }

    add() {
        this.resetDialogForm()
        this.dialogVisible = true
    }

    edit(row: any) {
        this.resetDialogForm()
        this.dialogForm = {
            id: row.id,
            symptomName: row.symptomName,
            remark: row.remark
        }
        this.dialogVisible = true
    }

    resetDialogForm() {
        this.dialogForm = {
            id: null,
            symptomName: "",
            remark: ""
        }
        this.$nextTick(() => {
            (this.$refs.formRef as any)?.clearValidate()
        })
    }

    handleClose() {
        this.cancel()
    }

    cancel() {
        this.dialogVisible = false
        this.resetDialogForm()
    }

    async save() {
        try {
            await (this.$refs.formRef as any).validate()
            this.saving = true

            tongueSubSymptom({ ...this.dialogForm }).then(() => {
                this.dialogVisible = false
                this.getData()
                this.$message.success("操作成功")
            })
        } catch (error) {

        } finally {
            this.saving = false
        }
    }
}
